import {ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot} from '@angular/router';
import {inject} from '@angular/core';
import {UrlParamLiterals} from '@ccp/enums/literals/urlparams.enum';
import {Views} from '@ccp/config/views';
import {UrlManager} from '@ccp/lib/url-manager';
import {CLAIM_DC_RESULT_PATH} from '@ccp/views/products/register/request-status/request-status-routing.routes';
import {ProductContextService} from '@ccp/services/app-context/product-context.service';

export const ProductGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const productContextService = inject(ProductContextService);

  const from = route.queryParamMap.get(UrlParamLiterals.From) || '';
  const warrantyUid = route.queryParamMap.get(UrlParamLiterals.WarrantyUid) || '';
  const isPos = from.notEmpty() && warrantyUid.notEmpty();

  if (
    isNSDWithSerial(route) ||
    isClaimDcResult(route, state) ||
    isPos ||
    productContextService.isProductBeingRegistered$() ||
    isDCTransfer(route)
  ) {
    return true;
  }
  return router.createUrlTree([Views.userRegister.path], {queryParams: route.queryParams});
};

function isNSDWithSerial(route: ActivatedRouteSnapshot) {
  return route.queryParamMap.get(UrlParamLiterals.Serial) && UrlManager.pathsIdentical(route.routeConfig.path, Views.noSellout.path);
}

function isClaimDcResult(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
  return (
    route.queryParamMap.get(UrlParamLiterals.Serial) && state.url?.includes(Views.productRequestStatus.path + '/' + CLAIM_DC_RESULT_PATH)
  );
}

function isDCTransfer(route: ActivatedRouteSnapshot) {
  return route.queryParamMap.get(UrlParamLiterals.TransferCode);
}
